import React from "react"
import { Navigate } from "react-router-dom"

// Dashboard
import Dashboard from "../pages/Dashboard/Dashboard"

// Authentication related pages
import LoginRoute from "./LoginRoute"
import ForgetPwd from "../pages/Authentication/ForgetPassword"

// Profile
import MyProfile from "../pages/Profile/MyProfile"
import EditProfile from "../pages/Profile/EditProfile"
import PublicProfile from "../pages/Profile/PublicProfile"
import VerifyOtp from "../pages/Authentication/verifyOtp"

// Onboarding
import OnboardingFlow from "../pages/Authentication/Onboarding/OnboardingFlow"
import ResetPassword from "../pages/Authentication/ResetPassword"
import RequestInvite from "../pages/Authentication/RequestInvite"
import CreateAccount from "../pages/Authentication/CreateAccount"

// Legal
import PrivacyPolicy from "../pages/Legal/PrivacyPolicy.jsx"
import TermsOfService from "../pages/Legal/TermsOfService.jsx"

// Projects
import ProjectsListing from "../pages/Projects/ProjectsListing"
import CreateProject from "../pages/Projects/CreateProject"
import ProjectLayout from "../pages/Projects/ProjectLayout"
import ProjectOverviewTab from "../pages/Projects/tabs/ProjectOverviewTab"
import ProjectTasksTab from "../pages/Projects/tabs/ProjectTasksTab"
import ProjectMyTasksTab from "../pages/Projects/tabs/ProjectMyTasksTab"
import ProjectSessionsTab from "../pages/Projects/tabs/ProjectSessionsTab"
import ProjectSessionDetailTab from "../pages/Projects/tabs/ProjectSessionDetailTab"
import ProjectCalendarTab from "../pages/Projects/tabs/ProjectCalendarTab"
import ProjectCollaboratorsTab from "../pages/Projects/tabs/ProjectCollaboratorsTab"
import ProjectMessagesTab from "../pages/Projects/tabs/ProjectMessagesTab"

// Collaborators
import Collaborators from "../pages/Collaborators/Collaborators"

// Activity Log
import ActivityLog from "../pages/ActivityLog/ActivityLog"

// Flags
import FlagsListing from "../pages/Flags/FlagsListing"
import FlagDetails from "../pages/Flags/FlagDetails"

// Invites
import Invites from "../pages/Invites/Invites"
import RewardsXp from "../pages/Rewards/RewardsXp"
import XpActivityListing from "../pages/Rewards/XpActivityListing"

// Notifications
import Notifications from "../pages/Notifications/Notifications"

// Rewards
import CallsForArtist from "../pages/CallsForArtist/CallsForArtist"
import CallForArtistDetail from "../pages/CallsForArtist/CallForArtistDetail"

// City Hub
import CityHub from "../pages/CityHub/CityHub"
import CityHubCallsTab from "../pages/CityHub/tabs/CityHubCallsTab"
import CityHubEventsTab from "../pages/CityHub/tabs/CityHubEventsTab"
import CityHubShadowEventDetailTab from "../pages/CityHub/tabs/CityHubShadowEventDetailTab"
import CityHubReviewsTab from "../pages/CityHub/tabs/CityHubReviewsTab"
import CityHubPhotographyTab from "../pages/CityHub/tabs/CityHubPhotographyTab"
import CityHubCreatorsTab from "../pages/CityHub/tabs/CityHubCreatorsTab"
import {
  CityHubCityRedirect,
  CityHubTabIndexRedirect,
} from "../pages/CityHub/CityHubLayout"
import CityHubDetail from "../pages/CityHub/CityHubDetail"
import CityHubInboxDetail from "../pages/CityHub/CityHubInboxDetail"
import CityHubEventDetail from "../pages/CityHub/CityHubEventDetail"
import CityHubBlogDetail from "../pages/CityHub/CityHubBlogDetail"
import PublicCityLayout, {
  PublicCitiesRedirect,
  PublicCityTabIndexRedirect,
} from "../pages/PublicCity/PublicCityLayout"

// Admin
import AdminRequests from "../pages/Admin/Requests/Requests"
import AdminPlaceholder from "../pages/Admin/AdminPlaceholder"
import AdminDashboard from "../pages/Admin/Dashboard/AdminDashboardEntry"
import AdminMembers from "../pages/Admin/Members/Members"
import AdminMemberDetail from "../pages/Admin/Members/MemberDetail"
import AdminMemberEdit from "../pages/Admin/Members/MemberEdit"
import AdminCities from "../pages/Admin/Cities/Cities"
import {
  AdminAddCity,
  AdminEditCity,
} from "../pages/Admin/Cities/CityForm"
import AdminCityDetail from "../pages/Admin/Cities/CityDetail"
import AdminCityProjects from "../pages/Admin/Cities/CityProjects"
import AdminCityReviews from "../pages/Admin/Cities/CityReviews"
import AdminCityCalls from "../pages/Admin/Cities/CityCalls"
import AdminCityPhotography from "../pages/Admin/Cities/CityPhotography"
import AdminCityFlags from "../pages/Admin/Cities/CityFlags"
import AdminCityTransfers from "../pages/Admin/Cities/CityTransfers"
import AdminCityShadowEvents from "../pages/Admin/Cities/CityShadowEvents"
import AdminCityRewards from "../pages/Admin/Cities/CityRewards"
import AdminCityRewardDetail from "../pages/Admin/Cities/CityRewardDetail"
import AdminProjects from "../pages/Admin/Projects/Projects"
import AdminSessions from "../pages/Admin/Sessions/Sessions"
import AdminSessionDetail from "../pages/Admin/Sessions/SessionDetail"
import AdminRewards from "../pages/Admin/Rewards/Rewards"
import AdminRewardDetail from "../pages/Admin/Rewards/RewardDetail"
import AdminInbox from "../pages/Admin/Inbox/Inbox"
import AdminInboxCallDetail from "../pages/Admin/Inbox/CallForArtistDetail"
import AdminRoles from "../pages/Admin/Roles/Roles"
import AdminCreateRole from "../pages/Admin/Roles/CreateRole"
import AdminRoleDetail from "../pages/Admin/Roles/RoleDetail"
import AdminArtsGenome from "../pages/Admin/ArtsGenome/ArtsGenome"
import ArtsGenomeForm from "../pages/Admin/ArtsGenome/ArtsGenomeForm"
import AdminSettings from "../pages/Admin/Settings/Settings"
import AdminStaff from "../pages/Admin/Staff/Staff"
import AdminStaffProfile from "../pages/Admin/Staff/StaffProfile"
import AdminMailGun from "../pages/Admin/MailGun/MailGun"
import AdminFlags from "../pages/Admin/Flags/Flags"
import AdminNotifications from "../pages/Admin/Notifications/Notifications"
import PhotographyListing from "../components/Listing/PhotographyListing"
import AdminCreateProject from "../pages/Admin/Projects/CreateProject"
import AdminProjectLayout from "../pages/Admin/Projects/ProjectLayout"
import AdminProjectOverviewTab from "../pages/Admin/Projects/tabs/ProjectOverviewTab"
import AdminProjectTasksTab from "../pages/Admin/Projects/tabs/ProjectTasksTab"
import AdminProjectMyTasksTab from "../pages/Admin/Projects/tabs/ProjectMyTasksTab"
import AdminProjectSessionsTab from "../pages/Admin/Projects/tabs/ProjectSessionsTab"
import AdminProjectSessionDetailTab from "../pages/Admin/Projects/tabs/ProjectSessionDetailTab"
import AdminProjectCalendarTab from "../pages/Admin/Projects/tabs/ProjectCalendarTab"
import AdminProjectCollaboratorsTab from "../pages/Admin/Projects/tabs/ProjectCollaboratorsTab"
import AdminProjectMessagesTab from "../pages/Admin/Projects/tabs/ProjectMessagesTab"
import CityPortalLegacyRedirect from "./CityPortalLegacyRedirect"

const userRoutes = [
  { path: "/dashboard", component: <Dashboard /> },

  // Projects
  { path: "/projects", component: <ProjectsListing /> },
  { path: "/projects/create", component: <CreateProject /> },
  { path: "/projects/:projectId/edit", component: <CreateProject /> },
  {
    path: "/projects/:projectId",
    component: <ProjectLayout />,
    children: [
      { index: true, component: <Navigate to="overview" replace /> },
      { path: "overview", component: <ProjectOverviewTab /> },
      { path: "tasks", component: <ProjectTasksTab /> },
      { path: "tasks/:memberId/detail/:taskId", component: <ProjectMyTasksTab /> },
      { path: "tasks/:memberId", component: <ProjectMyTasksTab /> },
      { path: "my-tasks", component: <ProjectMyTasksTab /> },
      { path: "sessions", component: <ProjectSessionsTab /> },
      { path: "sessions/:sessionId", component: <ProjectSessionDetailTab /> },
      { path: "calendar", component: <ProjectCalendarTab /> },
      { path: "collaborators", component: <ProjectCollaboratorsTab /> },
      { path: "messages/*", component: <ProjectMessagesTab /> },
    ],
  },

  // Collaborators
  { path: "/collaborators", component: <Collaborators /> },

  // Activity Log
  { path: "/activity-log", component: <ActivityLog /> },

  // Flags
  { path: "/flags", component: <FlagsListing /> },
  { path: "/flags/:flagId", component: <FlagDetails /> },

  // Invites
  { path: "/invites", component: <Invites /> },

  // Rewards
  { path: "/rewards/activity", component: <XpActivityListing /> },
  { path: "/rewards", component: <RewardsXp /> },

  // Notifications
  { path: "/notifications", component: <Notifications /> },

  // Legal
  { path: "/privacy-policy", component: <PrivacyPolicy /> },
  { path: "/terms-of-service", component: <TermsOfService /> },

  // Calls for Artist
  { path: "/calls-for-artist", component: <CallsForArtist /> },
  { path: "/calls-for-artist/:callId", component: <CallForArtistDetail /> },

  // City Hub
  { path: "/city-hub", component: <CityHubCityRedirect /> },
  {
    path: "/city-hub/:cityId",
    component: <CityHub />,
    children: [
      {
        index: true,
        component: <CityHubTabIndexRedirect />,
      },
      { path: "calls-for-artists", component: <CityHubCallsTab /> },
      {
        path: "city-inbox",
        component: <Navigate to="calls-for-artists" replace />,
      },
      {
        path: "shadow-working-events/:eventId",
        component: <CityHubShadowEventDetailTab />,
      },
      { path: "shadow-working-events", component: <CityHubEventsTab /> },
      { path: "local-reviews", component: <CityHubReviewsTab /> },
      { path: "photography", component: <CityHubPhotographyTab /> },
      { path: "creators", component: <CityHubCreatorsTab /> },
    ],
  },
  { path: "/city-hub/calls/:callId", component: <CityHubDetail /> },
  { path: "/city-hub/inbox/:inboxId", component: <CityHubInboxDetail /> },
  { path: "/city-hub/events/:eventId", component: <CityHubEventDetail /> },
  { path: "/city-hub/blogs/:blogId", component: <CityHubBlogDetail /> },

  // profile
  { path: "/public/profile/:profileId", component: <PublicProfile /> },
  { path: "/profile/edit/:profileId", component: <EditProfile /> },
  { path: "/profile/:profileId", component: <MyProfile /> },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
  { path: "*", component: <Navigate to="/dashboard" /> },
]

const adminRoutes = [
  { path: "/admin", component: <Navigate to="/admin/dashboard" replace /> },
  { path: "/admin/requests/:tab", component: <AdminRequests /> },
  { path: "/admin/requests", component: <AdminRequests /> },
  {
    path: "/admin/dashboard",
    component: <AdminDashboard />,
  },
  { path: "/admin/cities", component: <AdminCities /> },
  { path: "/admin/cities/create", component: <AdminAddCity /> },
  { path: "/admin/cities/:cityId/edit", component: <AdminEditCity /> },
  {
    path: "/admin/cities/:cityId/members/:profileId/edit",
    component: <AdminMemberEdit />,
  },
  {
    path: "/admin/cities/:cityId/members/:profileId",
    component: <AdminMemberDetail />,
  },
  {
    path: "/admin/cities/:cityId/members",
    component: <AdminMembers />,
  },
  {
    path: "/admin/cities/:cityId/projects",
    component: <AdminCityProjects />,
  },
  {
    path: "/admin/cities/:cityId/reviews",
    component: <AdminCityReviews />,
  },
  {
    path: "/admin/cities/:cityId/calls",
    component: <AdminCityCalls />,
  },
  {
    path: "/admin/cities/:cityId/shadow-working-events",
    component: <AdminCityShadowEvents />,
  },
  {
    path: "/admin/cities/:cityId/rewards/:rewardId",
    component: <AdminCityRewardDetail />,
  },
  {
    path: "/admin/cities/:cityId/rewards",
    component: <AdminCityRewards />,
  },
  {
    path: "/admin/cities/:cityId/photography",
    component: <AdminCityPhotography />,
  },
  {
    path: "/admin/cities/:cityId/flags",
    component: <AdminCityFlags />,
  },
  {
    path: "/admin/cities/:cityId/transfers",
    component: <AdminCityTransfers />,
  },
  { path: "/admin/cities/:cityId", component: <AdminCityDetail /> },
  {
    path: "/admin/projects",
    component: <AdminProjects />,
  },
  { path: "/admin/projects/create", component: <AdminCreateProject /> },
  { path: "/admin/projects/:projectId/edit", component: <AdminCreateProject /> },
  {
    path: "/admin/projects/:projectId",
    component: <AdminProjectLayout />,
    children: [
      { index: true, component: <Navigate to="overview" replace /> },
      { path: "overview", component: <AdminProjectOverviewTab /> },
      { path: "tasks", component: <AdminProjectTasksTab /> },
      {
        path: "tasks/:memberId/detail/:taskId",
        component: <AdminProjectMyTasksTab />,
      },
      { path: "tasks/:memberId", component: <AdminProjectMyTasksTab /> },
      { path: "my-tasks", component: <AdminProjectMyTasksTab /> },
      { path: "sessions", component: <AdminProjectSessionsTab /> },
      {
        path: "sessions/:sessionId",
        component: <AdminProjectSessionDetailTab />,
      },
      { path: "calendar", component: <AdminProjectCalendarTab /> },
      { path: "collaborators", component: <AdminProjectCollaboratorsTab /> },
      { path: "messages/*", component: <AdminProjectMessagesTab /> },
    ],
  },
  {
    path: "/admin/sessions/:sessionId",
    component: <AdminSessionDetail />,
  },
  {
    path: "/admin/sessions",
    component: <AdminSessions />,
  },
  { path: "/admin/members", component: <AdminMembers /> },
  { path: "/admin/members/:profileId/edit", component: <AdminMemberEdit /> },
  { path: "/admin/members/:profileId", component: <AdminMemberDetail /> },
  {
    path: "/admin/rewards/:rewardId",
    component: <AdminRewardDetail />,
  },
  {
    path: "/admin/rewards",
    component: <AdminRewards />,
  },
  {
    path: "/admin/inbox/:callId",
    component: <AdminInboxCallDetail />,
  },
  {
    path: "/admin/inbox",
    component: <AdminInbox />,
  },
  {
    path: "/admin/notifications",
    component: <AdminNotifications />,
  },
  {
    path: "/admin/activity-log",
    component: <ActivityLog />,
  },
  {
    path: "/admin/photography",
    component: (
      <PhotographyListing
        documentTitle="Photography | AMOK . EARTH Admin"
        showExport
        pageSize={10}
      />
    ),
  },
  {
    path: "/admin/arts-genome/:type/create",
    component: <ArtsGenomeForm mode="create" />,
  },
  {
    path: "/admin/arts-genome/:type/:itemId/edit",
    component: <ArtsGenomeForm mode="edit" />,
  },
  {
    path: "/admin/arts-genome",
    component: <AdminArtsGenome />,
  },
  {
    path: "/admin/blogs",
    component: <AdminPlaceholder title="Blogs Management" />,
  },
  {
    path: "/admin/flags",
    component: <AdminFlags />,
  },
  { path: "/admin/mailgun", component: <AdminMailGun /> },
  {
    path: "/admin/staff/:staffId",
    component: <AdminStaffProfile />,
  },
  {
    path: "/admin/staff",
    component: <AdminStaff />,
  },
  {
    path: "/admin/roles/create",
    component: <AdminCreateRole />,
  },
  {
    path: "/admin/roles/:roleId/edit",
    component: <AdminCreateRole />,
  },
  {
    path: "/admin/roles/:roleId",
    component: <AdminRoleDetail />,
  },
  {
    path: "/admin/roles",
    component: <AdminRoles />,
  },
  {
    path: "/admin/settings/:tab",
    component: <AdminSettings />,
  },
  {
    path: "/admin/settings",
    component: <AdminSettings />,
  },
]

const cityPortalLegacyRoutes = [
  {
    path: "/city-portal/*",
    component: <CityPortalLegacyRedirect />,
  },
]

const authRoutes = [
  { path: "/login", component: <LoginRoute /> },
  { path: "/verify-otp", component: <VerifyOtp /> },
  { path: "/forgot-password", component: <ForgetPwd /> },
  { path: "/reset-password", component: <ResetPassword /> },
  { path: "/request-invite", component: <RequestInvite /> },
  { path: "/create-account", component: <CreateAccount /> },
]

/** Guest-accessible public city pages (WordPress marketing chrome). */
const publicRoutes = [
  { path: "/public/cities", component: <PublicCitiesRedirect /> },
  {
    path: "/public/cities/:citySlug",
    component: <PublicCityLayout />,
    children: [
      { index: true, component: <PublicCityTabIndexRedirect /> },
      { path: "calls-for-artists", component: <CityHubCallsTab /> },
      { path: "shadow-working-events", component: <CityHubEventsTab /> },
      { path: "local-reviews", component: <CityHubReviewsTab /> },
      { path: "photography", component: <CityHubPhotographyTab /> },
    ],
  },
]

const onboardingRoutes = [
  {
    path: "/onboarding",
    component: <Navigate to="/onboarding/ongoing-roles" replace />,
  },
  { path: "/onboarding/:step", component: <OnboardingFlow /> },
]

export {
  userRoutes,
  authRoutes,
  publicRoutes,
  onboardingRoutes,
  adminRoutes,
  cityPortalLegacyRoutes,
}
